import React, { useState, useRef } from 'react';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
	root: {
		//
	}
}));

export default function CommentForm({ addDataToFormObject }) {
	const classes = useStyles();
	const id = 'CommentField';

	return (
		<form className={classes.root} noValidate autoComplete="off">
			<TextField
				fullWidth
				id={id}
				label="Add Comment"
				multiline
				rows={4}
				onChange={(e) => addDataToFormObject(id, e.target?.value)}
			/>
		</form>
	);
}
